import { useEffect, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';

import logo from '../../assets/images/logos/logo.png';
import { useAuth } from '../../hooks/auth';
import { AsideButton } from './components/AsideButton';
import SidebarData, { ISibebar } from './SidebarData';
import { CollapseToggle, Container } from './styles';

const STORAGE_KEY = '@Zignet:sidebarCollapsed';

export const AsideMenu = () => {
  const { user } = useAuth();

  const { pathname } = useLocation();

  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true'
  );
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsNarrow(window.innerWidth < 900);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // abaixo de 900px o menu vira sempre rail de icones, ignorando a preferencia.
  const isCollapsed = collapsed || isNarrow;

  const toggleCollapsed = () => {
    setCollapsed((previous) => {
      const next = !previous;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  };

  return (
    <Container $collapsed={isCollapsed}>
      <div className="logoContainer">
        <Link to="/admin/dashboard">
          <img src={logo} alt="Zignet" />
        </Link>
      </div>

      <ul>
        {SidebarData.filter(
          (data: ISibebar) =>
            user.profile === 'admin' ||
            (data.path !== 'pessoas' && !data.adminOnly)
        ).map((data: ISibebar) =>
          data.path ? (
            <Link to={data.path} key={data.id.toString()}>
              <AsideButton
                title={data.title}
                icon={data.icon}
                submenu={data.submenu}
                active={pathname.slice(7) === data.path ? 'active' : ''}
              />
            </Link>
          ) : (
            <AsideButton
              key={data.id.toString()}
              title={data.title}
              icon={data.icon}
              submenu={data.submenu}
            />
          )
        )}
      </ul>

      <CollapseToggle
        type="button"
        onClick={toggleCollapsed}
        disabled={isNarrow}
        $collapsed={isCollapsed}
        aria-label={isCollapsed ? 'Expandir menu' : 'Recolher menu'}
        title={isCollapsed ? 'Expandir menu' : 'Recolher menu'}
      >
        {isCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
      </CollapseToggle>
    </Container>
  );
};
